module.exports = {
  fetch: `
    query getOxygens {
      oxygens {
        id
        name {
          en
          es
        }
      }
    }
  `,
};
